import React from 'react';
import { Link } from 'react-router-dom';
import { getPortalToken } from '../api/client';

export default function ConfirmedPage() {
  const token = getPortalToken();

  return (
    <div className="page-wrapper" style={{ background: '#F0F4F8', minHeight: '100vh' }}>
<div className="public-nav-bar">
        <div className="public-nav-bar-inner">
          <Link to="/register" style={{ color: 'rgba(255,255,255,0.75)', fontSize: '0.875rem' }}>Iscrizioni</Link>
          <Link to="/accesso" style={{ color: 'rgba(255,255,255,0.75)', fontSize: '0.875rem' }}>Accedi</Link>
        </div>
      </div>

      <main className="public-main">
        <div
          className="public-card"
          style={{
            padding: '3rem 2.5rem',
            textAlign: 'center',
            maxWidth: '560px',
            margin: '2rem auto',
          }}
        >
          {/* Success icon */}
          <div
            style={{
              width: '80px',
              height: '80px',
              borderRadius: '50%',
              background: 'var(--success-light)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 1.5rem',
              fontSize: '2.5rem',
            }}
          >
            ✓
          </div>

          <h2
            style={{
              color: 'var(--pub-navy)',
              fontSize: '1.75rem',
              fontFamily: 'var(--font-public)',
              fontWeight: 700,
              marginBottom: '1rem',
            }}
          >
            Iscrizione completata!
          </h2>

          <p style={{ color: 'var(--gray-600)', fontSize: '1rem', marginBottom: '0.75rem' }}>
            Grazie per esserti iscritto. La tua richiesta è stata ricevuta con successo.
          </p>

          <p style={{ color: 'var(--gray-600)', fontSize: '1rem', marginBottom: '1.5rem' }}>
            Riceverai a breve una{' '}
            <strong>email di conferma</strong> con tutti i dettagli del corso. Monitora lo
            stato della tua iscrizione nella tua area personale.
          </p>

          <div
            style={{
              background: 'var(--gray-50)',
              border: '1px solid var(--gray-200)',
              borderRadius: 'var(--border-radius)',
              padding: '1rem 1.25rem',
              marginBottom: '2rem',
              textAlign: 'left',
            }}
          >
            <p style={{ fontWeight: 600, color: 'var(--gray-700)', marginBottom: '0.375rem' }}>
              Cosa succede adesso?
            </p>
            <ol
              style={{
                paddingLeft: '1.25rem',
                color: 'var(--gray-600)',
                fontSize: '0.9375rem',
                margin: 0,
              }}
            >
              <li style={{ marginBottom: '0.375rem' }}>
                Ricevi la conferma di iscrizione via email
              </li>
              <li style={{ marginBottom: '0.375rem' }}>
                Il tuo profilo viene registrato sulla piattaforma
              </li>
              <li style={{ marginBottom: '0.375rem' }}>
                Vieni registrato sulla sessione Zoom
              </li>
              <li>
                Ricevi il link per accedere al meeting prima della sessione
              </li>
            </ol>
          </div>

          {token ? (
            <Link
              to={`/area?token=${token}`}
              className="btn-pub-cta"
              style={{ display: 'inline-flex', width: '100%', justifyContent: 'center', textDecoration: 'none' }}
            >
              Vai alla tua area personale
            </Link>
          ) : (
            <Link
              to="/register"
              className="btn-pub-outline"
              style={{ display: 'inline-flex', width: '100%', justifyContent: 'center', textDecoration: 'none' }}
            >
              Torna alla registrazione
            </Link>
          )}

          <p style={{ marginTop: '1rem', fontSize: '0.875rem', color: 'var(--gray-500)' }}>
            Vuoi rientrare più tardi?{' '}
            <Link to="/accesso" style={{ color: 'var(--pub-blue)' }}>
              Recupera il tuo link di accesso
            </Link>
          </p>

          <p
            style={{
              marginTop: '1rem',
              fontSize: '0.8125rem',
              color: 'var(--gray-400)',
            }}
          >
            Problemi? Contattaci a{' '}
            <a href="mailto:marketing@switchonmedia.it">marketing@switchonmedia.it</a>
          </p>
        </div>
      </main>

      <footer style={{
        background: 'var(--pub-navy)', color: 'rgba(255,255,255,0.55)',
        fontSize: '0.8125rem', textAlign: 'center', padding: '1rem 2rem',
        fontFamily: 'var(--font-public)',
      }}>
        {import.meta.env.VITE_FOOTER_TEXT}
      </footer>
    </div>
  );
}
